  const firebaseConfig = {
    apiKey: "AIzaSyBnUyP-9hWMpsy65Wg1PudUdwJ6VTQPW0E",
    authDomain: "creative-agency-58a8d.firebaseapp.com",
    databaseURL: "https://creative-agency-58a8d.firebaseio.com",
    projectId: "creative-agency-58a8d",
    storageBucket: "creative-agency-58a8d.appspot.com",
    messagingSenderId: "271637921107",
    appId: "1:271637921107:web:1e8bf706ba54df8d4775a6"
  };

 export default firebaseConfig